import { render, staticRenderFns } from "./SidebarBtn.vue?vue&type=template&id=2ce64213&scoped=true&"
import script from "./SidebarBtn.vue?vue&type=script&lang=js&"
export * from "./SidebarBtn.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBtn.vue?vue&type=style&index=0&id=2ce64213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce64213",
  null
  
)

export default component.exports